<!--Main Navigation-->


    <!-- Sidebar -->    
    <div class="side-nav fixed wide" #sidenav style="background-color: white;" *ngIf="showMenus">
        <ul>
            <!-- Logo -->
            <li class="dooya-yellow">
                <span class="dooya-yellow" style="padding-bottom: 6px;">
                <a #logoLarge class="logo-wrapper waves-effect p-1" href="/dashboard">
                    <img
                        src="../../../assets/img/DooyaThin.png"
                        class="img-fluid py-0"
                        alt="Dooya"
                        style="max-height: 48px;"
                    />
                </a>
                </span>
                <span class="dooya-yellow" style="padding-bottom: 9px;">
                <a #logoSmall class="waves-effect p-1 d-none" href="/dashboard">
                    <img
                        src="../../../assets/img/d-icon.png"
                        class="img-fluid py-0"
                        alt="Dooya icon"    
                        style="max-height: 48px;"
                    />
                </a>
                </span>
            </li>
            <!--/. Logo -->
            <!-- Side navigation links -->
            <li>
                <ul class="collapsible collapsible-accordion">
                    <li>
                        <a routerLink="dashboard" routerLinkActive="active" (click)="menuClicked()"
                            class="list-group-item border border-0 list-group-item-action waves-effect">
                            <mdb-icon fas icon="home" class="mr-3"></mdb-icon>Home
                        </a>
                    </li>
                    <!-- <li>
                        <a routerLink="market-trades" routerLinkActive="active" (click)="menuClicked()"
                            class="list-group-item border border-0 list-group-item-action waves-effect">
                            <mdb-icon fas icon="fas fa-money-check-alt" class="mr-3"></mdb-icon>Market Trades
                        </a>
                    </li> -->
                    <!-- <li>
                        <a routerLink="trade-planning" routerLinkActive="active" (click)="menuClicked()"
                            class="list-group-item border border-0 list-group-item-action waves-effect">
                            <mdb-icon fas icon="fa fa-calendar-alt" class="mr-3"></mdb-icon>Trade
                        </a>
                    </li> -->
                    <li>
                        <a routerLink="trade-history" routerLinkActive="active" (click)="menuClicked()"
                            class="list-group-item border border-0 list-group-item-action waves-effect">
                            <mdb-icon fas icon="clipboard-list" class="mr-3"></mdb-icon>Trade History
                        </a>
                    </li>
                    <li>
                        <a routerLink="fia" routerLinkActive="active" (click)="menuClicked()"
                            class="list-group-item border border-0 list-group-item-action waves-effect ">
                            <mdb-icon fas icon="file-invoice-dollar" class="mr-3"></mdb-icon>FIA
                        </a>
                    </li>
                    <li>
                        <a class="list-group-item border border-0 list-group-item-action waves-effect"
                            (click)="toggleSideNav()">
                            <i #minimiseMenuBtn class="sv-slim-icon fas fa-angle-double-left"></i>Minimize
                            menu
                        </a>
                    </li>
                </ul>
            </li>
            <!--/. Side navigation links -->
        </ul>
    </div>
    <!--/. Sidebar navigation -->
    <!-- Sidebar -->

    <!--Navbar-->
    <mdb-navbar [containerInside]="false" SideClass="navbar navbar-expand navbar-expand-xs navbar-light dooya-yellow pr-0 nav-height" *ngIf="showMenus">

        <div id='settingsTitle' [ngStyle]="{'padding-left':settingsService.sidenavExpanded ? '240px' : '48px' }"
            class="mx-lg-5 nav-height" style="padding-top: 7px!important;">
            <h4 class="banner-header" *ngIf="showTextInHeader">{{headerText}}</h4>
        </div>
        <!-- Collapsible content -->
        <links class=" nav-height" style="padding-top: 7px!important;padding-bottom: 7px; ">            
            <!-- Search form -->
            <ul class="navbar-nav nav-flex-icons ml-auto" *ngIf="showMenus">
                <li class="nav-item">
                    <div class="btn-group" mdbDropdown>
                        <a mdbDropdownToggle type="button" class="dropdown-toggle nav-link pt-0 pb-0" mdbWavesEffect>
                            <img *ngIf="settingsService.userProfile?.avatarId" src="../../../assets/img/profilePictures/{{settingsService.userProfile?.avatarId}}.png"
                                alt="Avatar" class="md-avatar rounded-circle">
                        </a>
                        <div class="dropdown-menu dropdown-primary dropdown-menu-right py-0"
                            style="min-width: 20rem!important;">
                            <mdb-card class="">
                                <!--Bacground color-->
                                <div class="card-up indigo lighten-1">
                                </div>

                                <!--Avatar-->
                                <div class="avatar mx-auto pt-2">
                                    <img *ngIf="settingsService.userProfile?.avatarId" src="../../../assets/img/profilePictures/{{settingsService.userProfile?.avatarId}}.png"
                                        class="rounded-circle" style="max-width: 100px;;">
                                </div>

                                <mdb-card-body>
                                    <!--Name-->
                                    <mdb-card-title class="text-center">
                                        <h4>{{settingsService.userProfile?.fullName}}</h4>
                                        <h6><small>{{settingsService.user?.email}}</small></h6>
                                    </mdb-card-title>
                                    <a class="dropdown-item border border-right-0 border-left-0"
                                        routerLink="settings" >Settings</a>
                                    <a class="dropdown-item " (click)="Logout()">Sign out</a>
                                </mdb-card-body>
                            </mdb-card>
                        </div>
                    </div>
                </li>
            </ul>
        </links>
        <!-- Collapsible content -->

    </mdb-navbar>
    <!--/.Navbar-->


<!--Main Navigation-->